export default function WhyPhoneSalesChanged() {
  const oldWay = [
    'Можно было продавить — клиент не имел доступа к информации',
    'Работали скрипты — клиенты не были избалованы вниманием',
    'Менеджер был источником знаний — сейчас всё есть в интернете',
  ];

  const newWay = [
    'Клиент защищается — он получает десятки звонков в день',
    'Работает H2H — человек продаёт человеку, а не компании',
    'Доверие важнее информации — клиент купит у того, кому верит',
    'Метасообщения решают — тон, темп, паузы важнее слов',
    'Эмпатия создаёт контакт — понимание боли клиента открывает диалог',
    'Позиция эксперта — менеджер не просит, а помогает решить задачу',
    'SPIN-вопросы ведут клиента — правильные вопросы формируют потребность',
    'Управление разговором — менеджер ведёт беседу к следующему шагу',
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему телефонные продажи изменились
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Рынок перевернулся за последние 10 лет. Инструменты, которые работали раньше, сегодня отталкивают клиентов. Разберём, что изменилось и какие подходы реально работают сейчас.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 mb-16">
          <div className="bg-red-50 rounded-2xl p-6 md:p-8 border border-red-100">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-arrow-go-back-line text-red-500 text-lg"></i>
              </div>
              <h3 className="text-xl font-bold text-red-700">Раньше</h3>
            </div>
            <div className="space-y-4">
              {oldWay.map((text, i) => (
                <div key={i} className="flex items-start gap-3">
                  <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
                  <p className="text-sm text-gray-700 leading-relaxed">{text}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-teal-50 rounded-2xl p-6 md:p-8 border border-teal-100">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-rocket-line text-teal-600 text-lg"></i>
              </div>
              <h3 className="text-xl font-bold text-teal-700">Сегодня</h3>
            </div>
            <div className="space-y-4">
              {newWay.map((text, i) => (
                <div key={i} className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-teal-500 mt-0.5 flex-shrink-0"></i>
                  <p className="text-sm text-gray-700 leading-relaxed">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-center">
          <p className="text-xl md:text-2xl font-bold text-white leading-relaxed">
            Современные телефонные продажи — это не про скрипты и давление. Это про умение управлять разговором так, чтобы клиент сам захотел продолжить диалог.
          </p>
        </div>
      </div>
    </section>
  );
}